import React from 'react';
import { TH_COLUMNS } from '@components-shared/reports/tradingHistory/tableColumns';
import { TH_FILTER_FIELDS } from '@components-shared/reports/tradingHistory/tableFilters';
import { TableProps } from '@components-shared/table/types';
import Table from 'components/shared/table';
import { PlatformsType } from '../types';

interface ITradingHistoryProps {
  api: string;
  exportAPI: string;
  accountId: string;
  platformType?: string;
  withoutRouter?: boolean;
}

export const TradingHistory = ({ platformType, accountId, api, exportAPI }: ITradingHistoryProps): JSX.Element => {
  return (
    <Table
      tableId="trading-history"
      columns={TH_COLUMNS[platformType as PlatformsType] as TableProps['columns']}
      filterFields={TH_FILTER_FIELDS[platformType as PlatformsType] as TableProps['filterFields']}
      api={`${api}?id=${accountId}`}
      exportAPI={`${exportAPI}?id=${accountId}`}
    />
  );
};
